import { apiContractRequest } from "./client";

const jsonPost = (body) => ({ method: "POST", body });
const jsonPatch = (body) => ({ method: "PATCH", body });
const jsonPut = (body) => ({ method: "PUT", body });
const jsonDelete = () => ({ method: "DELETE" });

function buildOwnerImportFormData(file) {
  const formData = new FormData();
  formData.append("sourceType", "upload");
  formData.append("file", file);
  return formData;
}


export const ownerApi = {
  // WP-STANDARD | OWNER CRM FLOW + UNIVERSE CONTRACT
  // Status: RESTORED-FROM-PATCH-31 · API-CONTRACT · PATCH-35
  getCrmFlow() { return apiContractRequest("/api/owner/crm/flow").then((r)=>r?.flow||r); },
  saveCrmFlow(payload) { return apiContractRequest("/api/owner/crm/flow", jsonPut(payload)).then((r)=>r?.flow||r); },
  listCrmFlowCases() { return apiContractRequest("/api/owner/crm/flow/cases"); },
  assignCrmFlowCase(clientId, payload={}) { return apiContractRequest(`/api/owner/crm/flow/cases/${encodeURIComponent(clientId)}`, jsonPost(payload)); },
  updateCrmFlowNode(caseId, blockId, payload={}) { return apiContractRequest(`/api/owner/crm/flow/cases/${encodeURIComponent(caseId)}/nodes/${encodeURIComponent(blockId)}`, jsonPatch(payload)); },
  moveCrmFlowCase(caseId, payload={}) { return apiContractRequest(`/api/owner/crm/flow/cases/${encodeURIComponent(caseId)}/move`, jsonPatch(payload)); },
  getCrmFlowIntelligence() { return apiContractRequest("/api/owner/crm/flow/intelligence"); },
  exportCrmUniverse() { return apiContractRequest("/api/owner/crm/universe/export"); },
  previewCrmUniverseImport(payload={}) { return apiContractRequest("/api/owner/crm/universe/import/preview", jsonPost(payload)); },
  commitCrmUniverseImport(payload={}) { return apiContractRequest("/api/owner/crm/universe/import", jsonPost(payload)); },
  // WP-STANDARD | MULTI-OWNER ACCESS ADMIN
  // Status: SUPEROWNER-ONLY-BACKEND · v1
  ownerAccessMembers() {
    return apiContractRequest("/api/owner/access/members");
  },
  ownerAccessCandidates({ query = "" } = {}) {
    return apiContractRequest("/api/owner/access/candidates", { params: { query } });
  },
  saveOwnerAccessMember(payload = {}) {
    return apiContractRequest("/api/owner/access/members", { method: "PUT", body: payload });
  },
  revokeOwnerAccessMember(userId) {
    return apiContractRequest(`/api/owner/access/members/${encodeURIComponent(userId)}`, jsonDelete());
  },
  // WP-STANDARD | OWNER WHATSAPP BUSINESS ABM
  // Status: API-CONTRACT · SECRET-SAFE · v1
  whatsappBusinessStatus() { return apiContractRequest("/api/owner/whatsapp"); },
  whatsappBusinessObservability({ limit = 100, compact = false } = {}) { return apiContractRequest("/api/owner/whatsapp/observability", { params:{ limit, ...(compact ? { compact:1 } : {}) } }); },
  memoryDebug({ limit = 8 } = {}) { return apiContractRequest("/api/owner/observability/memory", { params:{ limit } }); },
  whatsappBusinessExport({ limit = 5000, waId = "", scope = "" } = {}) { return apiContractRequest("/api/owner/whatsapp/export", { params:{ limit, ...(waId ? { waId } : {}), ...(scope ? { scope } : {}) } }); },
  whatsappBusinessLinkContact(waId, clientId) { return apiContractRequest(`/api/owner/whatsapp/contacts/${encodeURIComponent(waId)}/link`, jsonPatch({ clientId })); },
  whatsappBusinessUpdatePhone(clientId, phone, source = "manual") { return apiContractRequest(`/api/owner/whatsapp/directory/${encodeURIComponent(clientId)}/phone`, jsonPatch({ phone, source })); },
  whatsappBusinessUpdateCrm(clientId, payload) { return apiContractRequest(`/api/owner/whatsapp/directory/${encodeURIComponent(clientId)}/crm`, jsonPatch(payload)); },
  whatsappBusinessChatMessages(waId, { limit = 150, beforeAt = "", beforeId = "" } = {}) { return apiContractRequest(`/api/owner/whatsapp/chats/${encodeURIComponent(waId)}/messages`, { params:{ limit, ...(beforeAt ? { beforeAt } : {}), ...(beforeId ? { beforeId } : {}) } }); },
  whatsappBusinessSendText(waId, text) { return apiContractRequest(`/api/owner/whatsapp/chats/${encodeURIComponent(waId)}/messages`, jsonPost({ text })); },
  whatsappBusinessAiStatus(waId) { return apiContractRequest(`/api/owner/whatsapp/chats/${encodeURIComponent(waId)}/ai`); },
  whatsappBusinessSetAi(waId, value) { const payload = typeof value === "object" && value !== null ? value : { enabled:Boolean(value) }; return apiContractRequest(`/api/owner/whatsapp/chats/${encodeURIComponent(waId)}/ai`, jsonPut(payload)); },
  whatsappOwnerCommandStatus(waId) { return apiContractRequest(`/api/owner/whatsapp/chats/${encodeURIComponent(waId)}/owner-command`); },
  whatsappOwnerCommandSet(waId, enabled) { return apiContractRequest(`/api/owner/whatsapp/chats/${encodeURIComponent(waId)}/owner-command`, jsonPut({ enabled:Boolean(enabled) })); },
  whatsappAiAssistantConfig() { return apiContractRequest("/api/owner/whatsapp/ai-assistant"); },
  whatsappAiAssistantSave(payload) { return apiContractRequest("/api/owner/whatsapp/ai-assistant", jsonPut(payload)); },
  whatsappAiContextPreview(waId) { return apiContractRequest("/api/owner/whatsapp/ai-assistant/context-preview", jsonPost({ waId })); },
  whatsappCommunicationActions(params = {}) { return apiContractRequest("/api/owner/whatsapp/communication-actions", { params }); },
  whatsappCommunicationActionCreate(payload = {}) { return apiContractRequest("/api/owner/whatsapp/communication-actions", jsonPost(payload)); },
  whatsappCommunicationActionGet(actionId) { return apiContractRequest(`/api/owner/whatsapp/communication-actions/${encodeURIComponent(actionId)}`); },
  whatsappCommunicationActionPatch(actionId, payload = {}) { return apiContractRequest(`/api/owner/whatsapp/communication-actions/${encodeURIComponent(actionId)}`, jsonPatch(payload)); },
  whatsappCommunicationActionSimulate(actionId) { return apiContractRequest(`/api/owner/whatsapp/communication-actions/${encodeURIComponent(actionId)}/simulate`, jsonPost({})); },
  whatsappCommunicationActionDraft(actionId, text) { return apiContractRequest(`/api/owner/whatsapp/communication-actions/${encodeURIComponent(actionId)}/draft`, jsonPatch({ text })); },
  whatsappCommunicationActionApprove(actionId) { return apiContractRequest(`/api/owner/whatsapp/communication-actions/${encodeURIComponent(actionId)}/approve`, jsonPost({})); },
  whatsappCommunicationActionSchedule(actionId, payload = {}) { return apiContractRequest(`/api/owner/whatsapp/communication-actions/${encodeURIComponent(actionId)}/schedule`, jsonPost(payload)); },
  whatsappCommunicationActionReschedule(actionId, payload = {}) { return apiContractRequest(`/api/owner/whatsapp/communication-actions/${encodeURIComponent(actionId)}/reschedule`, jsonPost(payload)); },
  whatsappCommunicationActionSendNow(actionId) { return apiContractRequest(`/api/owner/whatsapp/communication-actions/${encodeURIComponent(actionId)}/send-now`, jsonPost({})); },
  whatsappCommunicationActionCancel(actionId, payload = {}) { return apiContractRequest(`/api/owner/whatsapp/communication-actions/${encodeURIComponent(actionId)}/cancel`, jsonPost(payload)); },
  whatsappCommunicationActionExport(actionId) { return apiContractRequest(`/api/owner/whatsapp/communication-actions/${encodeURIComponent(actionId)}/export`); },
  saveWhatsappBusiness(payload = {}) { return apiContractRequest("/api/owner/whatsapp", { method:"PUT", body:payload }); },
  deleteWhatsappBusiness() { return apiContractRequest("/api/owner/whatsapp", jsonDelete()); },
  whatsappBaileysConnect() { return apiContractRequest("/api/owner/whatsapp/baileys/connect", jsonPost({})); },
  whatsappBaileysStatus() { return apiContractRequest("/api/owner/whatsapp/baileys/status"); },
  whatsappBaileysSync() { return apiContractRequest("/api/owner/whatsapp/baileys/sync", jsonPost({})); },
  whatsappBaileysRelinkHistory() { return apiContractRequest("/api/owner/whatsapp/baileys/relink-history", jsonPost({})); },
  whatsappBaileysDisconnect({ clearAuth = true } = {}) { return apiContractRequest("/api/owner/whatsapp/baileys/disconnect", jsonPost({ clearAuth })); },
  overview() {
    return apiContractRequest("/api/owner/overview");
  },

  center() {
    return apiContractRequest("/api/owner/center");
  },
  brain({ currency = "ARS", tzOffsetMinutes = new Date().getTimezoneOffset() } = {}) {
    return apiContractRequest("/api/owner/brain", { params: { currency, tzOffsetMinutes } });
  },
  brainDay({ currency = "ARS", tzOffsetMinutes = new Date().getTimezoneOffset() } = {}) {
    return apiContractRequest("/api/owner/brain/day", { params: { currency, tzOffsetMinutes } });
  },
  brainWeek({ currency = "ARS", tzOffsetMinutes = new Date().getTimezoneOffset() } = {}) {
    return apiContractRequest("/api/owner/brain/week", { params: { currency, tzOffsetMinutes } });
  },
  brainMonth({ currency = "ARS", tzOffsetMinutes = new Date().getTimezoneOffset() } = {}) {
    return apiContractRequest("/api/owner/brain/month", { params: { currency, tzOffsetMinutes } });
  },
  brainWhatNow({ currency = "ARS", tzOffsetMinutes = new Date().getTimezoneOffset() } = {}) {
    return apiContractRequest("/api/owner/brain/what-now", { params: { currency, tzOffsetMinutes } });
  },
  state({ month, date, currency = "ARS", tzOffsetMinutes = new Date().getTimezoneOffset() } = {}) {
    return apiContractRequest("/api/owner/state", { params: { month, date, currency, tzOffsetMinutes } });
  },
  assistant({ month, currency = "ARS", tzOffsetMinutes = new Date().getTimezoneOffset() } = {}) {
    return apiContractRequest("/api/owner/assistant", { params: { month, currency, tzOffsetMinutes } });
  },
  // WP-STANDARD | OWNER FUNCTIONAL STATE EXPORT
  // Status: API-CONTRACT · READ-ONLY · SECRET-SAFE · v2
  diagnosticExport({ daysBack = 120, daysForward = 120, limit = 500, currency = "ARS", tzOffsetMinutes = new Date().getTimezoneOffset() } = {}) {
    return apiContractRequest("/api/owner/diagnostics/export", { params: { daysBack, daysForward, limit, currency, tzOffsetMinutes } });
  },
  openAiUsage({ days = 30 } = {}) {
    return apiContractRequest("/api/owner/ai-usage", { params: { days } });
  },
  jarvisTurn(payload = {}) {
    return apiContractRequest("/api/owner/jarvis/turn", jsonPost({
      ...payload,
      tzOffsetMinutes: payload.tzOffsetMinutes ?? new Date().getTimezoneOffset(),
    }));
  },
  jarvisGuardian({ tzOffsetMinutes = new Date().getTimezoneOffset() } = {}) {
    return apiContractRequest("/api/owner/jarvis/guardian", { params: { tzOffsetMinutes } });
  },
  dayGuardian({ tzOffsetMinutes = new Date().getTimezoneOffset() } = {}) {
    return apiContractRequest("/api/owner/jarvis/day-guardian", { params: { tzOffsetMinutes } });
  },
  jarvisCapabilityCatalog() {
    return apiContractRequest("/api/owner/jarvis/intelligence/catalog");
  },
  jarvisCoverage() {
    return apiContractRequest("/api/owner/jarvis/intelligence/coverage");
  },
  jarvisMetrics({ days = 7 } = {}) {
    return apiContractRequest("/api/owner/jarvis/intelligence/metrics", { params: { days } });
  },
  jarvisCapabilityGaps({ limit = 100, status = "open" } = {}) {
    return apiContractRequest("/api/owner/jarvis/intelligence/gaps", { params: { limit, status } });
  },
  updateJarvisCapabilityGap(gapId, payload = {}) {
    return apiContractRequest(`/api/owner/jarvis/intelligence/gaps/${encodeURIComponent(gapId)}`, jsonPatch(payload));
  },
  reportJarvisUnhandled(payload = {}) {
    return apiContractRequest("/api/owner/jarvis/intelligence/gaps/report", jsonPost(payload));
  },
  reportJarvisResolution(payload = {}) {
    return apiContractRequest("/api/owner/jarvis/intelligence/resolutions/report", jsonPost(payload));
  },
  exportJarvisCapabilityGaps({ status = "open", limit = 500 } = {}) {
    return apiContractRequest("/api/owner/jarvis/intelligence/gaps/export", { params: { status, limit } });
  },
  jarvisBacklogConfig() {
    return apiContractRequest("/api/owner/jarvis/backlog/config");
  },
  saveJarvisBacklogConfig(payload = {}) {
    return apiContractRequest("/api/owner/jarvis/backlog/config", { method: "PUT", body: payload });
  },
  deleteJarvisBacklogConfig() {
    return apiContractRequest("/api/owner/jarvis/backlog/config", { method: "DELETE" });
  },
  testJarvisBacklog() {
    return apiContractRequest("/api/owner/jarvis/backlog/test", jsonPost({}));
  },
  prepareJarvisBacklog() {
    return apiContractRequest("/api/owner/jarvis/backlog/prepare", jsonPost({}));
  },
  syncJarvisBacklog() {
    return apiContractRequest("/api/owner/jarvis/backlog/sync", jsonPost({}));
  },
  nextJarvisBacklogReview({ markAsked = true } = {}) {
    return apiContractRequest("/api/owner/jarvis/backlog/review-next", { params: { markAsked } });
  },
  jarvisBacklogQueue({ refresh = true } = {}) {
    return apiContractRequest("/api/owner/jarvis/backlog/queue", { params: { refresh } });
  },
  listJarvisBacklog({ limit = 80, status = "" } = {}) {
    return apiContractRequest("/api/owner/jarvis/backlog/items", { params: { limit, ...(status ? { status } : {}) } });
  },
  createJarvisBacklogItem(payload = {}) {
    return apiContractRequest("/api/owner/jarvis/backlog/items", jsonPost(payload));
  },
  updateJarvisBacklogItem(externalId, payload = {}) {
    return apiContractRequest(`/api/owner/jarvis/backlog/items/${encodeURIComponent(externalId)}`, jsonPatch(payload));
  },
  reviewJarvisBacklogItem(externalId, payload = {}) {
    return apiContractRequest(`/api/owner/jarvis/backlog/items/${encodeURIComponent(externalId)}/review`, jsonPost(payload));
  },
  deleteJarvisBacklogItem(externalId) {
    return apiContractRequest(`/api/owner/jarvis/backlog/items/${encodeURIComponent(externalId)}`, jsonDelete());
  },
  ownerActionCapabilities() {
    return apiContractRequest("/api/owner/actions/capabilities");
  },
  ownerActionCommand(text, payload = {}) {
    return apiContractRequest("/api/owner/actions/command", jsonPost({
      text,
      tzOffsetMinutes: new Date().getTimezoneOffset(),
      ...payload,
    }));
  },
  shortcutStatus() {
    return apiContractRequest("/api/owner/actions/shortcut");
  },
  rotateShortcut() {
    return apiContractRequest("/api/owner/actions/shortcut/rotate", jsonPost({}));
  },
  revokeShortcut() {
    return apiContractRequest("/api/owner/actions/shortcut", jsonDelete());
  },
  decisionPolicy() {
    return apiContractRequest("/api/owner/decisions/policy");
  },
  updateDecisionPolicy(payload = {}) {
    return apiContractRequest("/api/owner/decisions/policy", { method: "PUT", body: payload });
  },
  testCalendarDecision(event) {
    return apiContractRequest("/api/owner/decisions/calendar/test", jsonPost({ event }));
  },
  decisionTraces({ limit = 120 } = {}) {
    return apiContractRequest("/api/owner/decisions/traces", { params: { limit } });
  },
  refreshDecisionTraces(payload = {}) {
    return apiContractRequest("/api/owner/decisions/traces/refresh", jsonPost(payload));
  },
  // WP-STANDARD | OWNER THREADS / CONTINUITY
  // Status: API-CONTRACT · OWNER-ONLY · v1
  threads({ status = "open", priority = "", query = "", limit = 120 } = {}) {
    return apiContractRequest("/api/owner/threads", { params: { status, priority, query, limit } });
  },
  thread(threadId) {
    return apiContractRequest(`/api/owner/threads/${encodeURIComponent(threadId)}`);
  },
  webProfitCoreThreadProject() {
    return apiContractRequest("/api/owner/threads/system/webprofit");
  },
  createThread(payload = {}) {
    return apiContractRequest("/api/owner/threads", jsonPost(payload));
  },
  updateThread(threadId, payload = {}) {
    return apiContractRequest(`/api/owner/threads/${encodeURIComponent(threadId)}`, jsonPatch(payload));
  },
  addThreadNote(threadId, payload = {}) {
    return apiContractRequest(`/api/owner/threads/${encodeURIComponent(threadId)}/notes`, jsonPost(payload));
  },
  addThreadTask(threadId, payload = {}) {
    return apiContractRequest(`/api/owner/threads/${encodeURIComponent(threadId)}/tasks`, jsonPost(payload));
  },
  addThreadTime(threadId, payload = {}) {
    return apiContractRequest(`/api/owner/threads/${encodeURIComponent(threadId)}/time`, jsonPost(payload));
  },
  addThreadInteraction(threadId, payload = {}) {
    return apiContractRequest(`/api/owner/threads/${encodeURIComponent(threadId)}/interactions`, jsonPost(payload));
  },
  linkInboxThread(threadId, inboxItemId) {
    return apiContractRequest(`/api/owner/threads/${encodeURIComponent(threadId)}/inbox`, jsonPost({ inboxItemId }));
  },

  inbox({ status = "open", limit = 200 } = {}) {
    return apiContractRequest("/api/owner/inbox", { params: { status, limit } });
  },
  inboxSummary({ limit = 120 } = {}) {
    return apiContractRequest("/api/owner/inbox/summary", { params: { limit } });
  },
  applyCalendarReading(payload = {}) {
    return apiContractRequest("/api/owner/inbox/calendar/apply", jsonPost(payload));
  },
  createInboxItem(payload = {}) {
    return apiContractRequest("/api/owner/inbox", jsonPost(payload));
  },
  updateInboxItem(itemId, payload = {}) {
    return apiContractRequest(`/api/owner/inbox/${encodeURIComponent(itemId)}`, jsonPatch(payload));
  },
  deleteInboxItem(itemId) {
    return apiContractRequest(`/api/owner/inbox/${encodeURIComponent(itemId)}`, jsonDelete());
  },
  reanalyzeInboxItem(itemId) {
    return apiContractRequest(`/api/owner/inbox/${encodeURIComponent(itemId)}/reanalyze`, jsonPost({}));
  },
  // WP-STANDARD | BULK REPENSAR EN SISTEMA
  // Status: API-CONTRACT · OWNER-CONTEXT · v1
  reanalyzeInboxSystem({ limit = 24 } = {}) {
    return apiContractRequest("/api/owner/inbox/reanalyze/system", jsonPost({ limit }));
  },
  exportInboxAnalysis({ daysBack = 365, daysForward = 365, limit = 1000 } = {}) {
    return apiContractRequest("/api/owner/inbox/export/analysis", { params: { daysBack, daysForward, limit } });
  },
  deduplicateInbox() {
    return apiContractRequest("/api/owner/inbox/deduplicate", jsonPost({}));
  },
  refreshInboxSummary() {
    return apiContractRequest("/api/owner/inbox/summary/refresh", jsonPost({}));
  },
  reconcileCalendar({ collectionHorizonDays = 7 } = {}) {
    return apiContractRequest("/api/owner/calendar/reconcile", jsonPost({ collectionHorizonDays }));
  },
  calendar({ month, date, tzOffsetMinutes = new Date().getTimezoneOffset() } = {}) {
    return apiContractRequest("/api/owner/calendar", { params: { month, date, tzOffsetMinutes } });
  },
  updateCalendarSettings(payload) {
    return apiContractRequest("/api/owner/calendar/settings", jsonPatch(payload));
  },
  applyCalendarPlan({ date, tzOffsetMinutes = new Date().getTimezoneOffset() } = {}) {
    return apiContractRequest("/api/owner/calendar/plan/apply", jsonPost({ date, tzOffsetMinutes }));
  },
  openOwnerDay({ date, note = "", tzOffsetMinutes = new Date().getTimezoneOffset() } = {}) {
    return apiContractRequest("/api/owner/calendar/day/open", jsonPost({ date, note, tzOffsetMinutes }));
  },
  closeOwnerDay({ date, note = "", rollover = "keep", tzOffsetMinutes = new Date().getTimezoneOffset() } = {}) {
    return apiContractRequest("/api/owner/calendar/day/close", jsonPost({ date, note, rollover, tzOffsetMinutes }));
  },
  startDayActivity(payload = {}) {
    return apiContractRequest("/api/owner/calendar/activity/start", jsonPost(payload));
  },
  stopDayActivity(payload = {}) {
    return apiContractRequest("/api/owner/calendar/activity/stop", jsonPost(payload));
  },
  listPlannedBlocks({ startAt, endAt } = {}) {
    return apiContractRequest("/api/owner/calendar/plans", { params:{ startAt, endAt } });
  },
  createPlannedBlock(payload = {}) {
    return apiContractRequest("/api/owner/calendar/plans", jsonPost(payload));
  },
  updatePlannedBlock(blockId, payload = {}) {
    return apiContractRequest(`/api/owner/calendar/plans/${blockId}`, jsonPatch(payload));
  },
  syncPlannedBlocks(payload = {}) {
    return apiContractRequest("/api/owner/calendar/plans/sync", jsonPost(payload));
  },
  planVsReality({ startAt, endAt } = {}) {
    return apiContractRequest("/api/owner/calendar/plan-vs-reality", { params:{ startAt, endAt } });
  },
  planningConflicts({ startAt, endAt } = {}) {
    return apiContractRequest("/api/owner/calendar/conflicts", { params:{ startAt, endAt } });
  },
  rematchActivityPlan(activityId, plannedBlockId, requestKey = "") {
    return apiContractRequest(`/api/owner/calendar/activity/${activityId}/plan`, jsonPatch({ plannedBlockId, requestKey }));
  },
  listRoutines({ includeInactive = true, limit = 150 } = {}) {
    return apiContractRequest("/api/owner/calendar/routines", { params: { includeInactive, limit } });
  },
  routineContext(routineId) {
    return apiContractRequest(`/api/owner/calendar/routines/${routineId}`);
  },
  createRoutine(payload) {
    return apiContractRequest("/api/owner/calendar/routines", jsonPost(payload));
  },
  updateRoutine(routineId, payload) {
    return apiContractRequest(`/api/owner/calendar/routines/${routineId}`, jsonPatch(payload));
  },
  setRoutineCheckin(routineId, date, completed = true) {
    return apiContractRequest(`/api/owner/calendar/routines/${routineId}/checkins/${encodeURIComponent(date)}`, jsonPatch({ completed }));
  },
  notifications({ limit = 40 } = {}) {
    return apiContractRequest("/api/owner/notifications", { params: { limit } });
  },
  updateNotifications(payload = {}) {
    return apiContractRequest("/api/owner/notifications", { method: "PUT", body: { ...payload, tzOffsetMinutes: payload.tzOffsetMinutes ?? new Date().getTimezoneOffset() } });
  },
  subscribeNotificationsPush(subscription) {
    return apiContractRequest("/api/owner/notifications/push/subscribe", jsonPost({ subscription }));
  },
  unsubscribeNotificationsPush(endpoint) {
    return apiContractRequest("/api/owner/notifications/push/subscribe", { method: "DELETE", body: { endpoint } });
  },
  testDailyCompanion() {
    return apiContractRequest("/api/owner/notifications/companion/test", jsonPost({}));
  },
  testNotificationsPush() {
    return apiContractRequest("/api/owner/notifications/push/test", jsonPost({}));
  },
  evaluateAttention() {
    return apiContractRequest("/api/owner/notifications/attention/evaluate", jsonPost({}));
  },
  snoozeAttention(candidateId, until, reason = "manual_snooze") {
    return apiContractRequest(`/api/owner/notifications/attention/${candidateId}/snooze`, jsonPatch({ until, reason }));
  },
  resolveAttention(candidateId, reason = "manual_resolve") {
    return apiContractRequest(`/api/owner/notifications/attention/${candidateId}/resolve`, jsonPatch({ reason }));
  },

  googleCalendarStatus() {
    return apiContractRequest("/api/owner/calendar/google");
  },
  saveGoogleCalendarProviderConfig(payload) {
    return apiContractRequest("/api/owner/calendar/google/provider", { method: "PUT", body: payload });
  },
  deleteGoogleCalendarProviderConfig() {
    return apiContractRequest("/api/owner/calendar/google/provider", jsonDelete());
  },
  startGoogleCalendarConnection() {
    return apiContractRequest("/api/owner/calendar/google/connect", jsonPost({}));
  },
  listGoogleCalendars() {
    return apiContractRequest("/api/owner/calendar/google/calendars");
  },
  selectGoogleCalendar(calendarId) {
    return apiContractRequest("/api/owner/calendar/google/calendar", jsonPatch({ calendarId }));
  },
  updateGoogleCalendarSettings(payload) {
    return apiContractRequest("/api/owner/calendar/google/settings", jsonPatch(payload));
  },
  testGoogleCalendarConnection() {
    return apiContractRequest("/api/owner/calendar/google/test", jsonPost({}));
  },
  syncGoogleCalendarNow() {
    return apiContractRequest("/api/owner/calendar/google/sync", jsonPost({}));
  },
  disconnectGoogleCalendar() {
    return apiContractRequest("/api/owner/calendar/google", jsonDelete());
  },
  listGoogleCalendarEvents({ daysBack = 30, daysForward = 60, fast = false } = {}) {
    return apiContractRequest("/api/owner/calendar/google/events", { params: { daysBack, daysForward, ...(fast ? { fast:"true" } : {}) } });
  },
  createGoogleCalendarEvent(payload) {
    return apiContractRequest("/api/owner/calendar/google/events", jsonPost(payload));
  },
  updateGoogleCalendarEvent(eventId, payload) {
    return apiContractRequest(`/api/owner/calendar/google/events/${encodeURIComponent(eventId)}`, jsonPatch(payload));
  },
  deleteGoogleCalendarEvent(eventId) {
    return apiContractRequest(`/api/owner/calendar/google/events/${encodeURIComponent(eventId)}`, jsonDelete());
  },
  previewCalendarAction(event) {
    return apiContractRequest("/api/owner/calendar/actions/preview", jsonPost({ event }));
  },
  commitCalendarAction(payload) {
    return apiContractRequest("/api/owner/calendar/actions/commit", jsonPost(payload));
  },
  calendarOrder(orderId) {
    return apiContractRequest(`/api/owner/calendar/orders/${encodeURIComponent(orderId)}`);
  },
  executeCalendarOrder(orderId, payload = {}) {
    return apiContractRequest(`/api/owner/calendar/orders/${encodeURIComponent(orderId)}/execute`, jsonPost(payload));
  },
  habits({ date, historyDays = 7, tzOffsetMinutes = new Date().getTimezoneOffset() } = {}) {
    return apiContractRequest("/api/owner/habits", { params: { date, historyDays, tzOffsetMinutes } });
  },
  sleep({ days = 14, tzOffsetMinutes = new Date().getTimezoneOffset() } = {}) {
    return apiContractRequest("/api/owner/habits/sleep", { params: { days, tzOffsetMinutes } });
  },
  recordSleepFact(payload = {}) {
    return apiContractRequest("/api/owner/habits/sleep/facts", jsonPost({ ...payload, tzOffsetMinutes: payload.tzOffsetMinutes ?? new Date().getTimezoneOffset() }));
  },
  updateSleepSession(sessionId, payload = {}) {
    return apiContractRequest(`/api/owner/habits/sleep/sessions/${encodeURIComponent(sessionId)}`, jsonPatch({ ...payload, tzOffsetMinutes: payload.tzOffsetMinutes ?? new Date().getTimezoneOffset() }));
  },
  createHabit(payload) {
    return apiContractRequest("/api/owner/habits", jsonPost(payload));
  },
  updateHabit(habitId, payload) {
    return apiContractRequest(`/api/owner/habits/${encodeURIComponent(habitId)}`, jsonPatch(payload));
  },
  setHabitCheckin(habitId, date, completed = true, payload = {}) {
    return apiContractRequest(`/api/owner/habits/${encodeURIComponent(habitId)}/checkins/${encodeURIComponent(date)}`, jsonPatch({ completed, ...payload }));
  },
  nutrition({ date, historyDays = 7, tzOffsetMinutes = new Date().getTimezoneOffset() } = {}) {
    return apiContractRequest("/api/owner/nutrition", { params: { date, historyDays, tzOffsetMinutes } });
  },
  foodMetrics({ period = "month", from = "", to = "", days = 0, planningLookbackDays = 30, shoppingHorizonDays = 14, tzOffsetMinutes = new Date().getTimezoneOffset() } = {}) {
    return apiContractRequest("/api/owner/nutrition/metrics", { params: { period, from, to, days, planningLookbackDays, shoppingHorizonDays, tzOffsetMinutes } });
  },
  logMeal(text, payload = {}) {
    return apiContractRequest("/api/owner/nutrition/meals", jsonPost({ text, tzOffsetMinutes: new Date().getTimezoneOffset(), ...payload }));
  },
  updateMeal(mealId, payload) {
    return apiContractRequest(`/api/owner/nutrition/meals/${encodeURIComponent(mealId)}`, jsonPatch(payload));
  },
  deleteMeal(mealId) {
    return apiContractRequest(`/api/owner/nutrition/meals/${encodeURIComponent(mealId)}`, jsonDelete());
  },
  updateFoodKnowledge(foodId, payload) {
    return apiContractRequest(`/api/owner/nutrition/foods/${encodeURIComponent(foodId)}`, jsonPatch(payload));
  },
  kitchenSnapshot({ limit = 40 } = {}) {
    return apiContractRequest("/api/owner/nutrition/kitchen", { params: { limit } });
  },
  kitchenIdeas(message = "") {
    return apiContractRequest("/api/owner/nutrition/kitchen/suggest", jsonPost({ message }));
  },
  foodCatalog({ query = "", limit = 120 } = {}) {
    return apiContractRequest("/api/owner/nutrition/catalog", { params: { ...(query ? { query } : {}), limit } });
  },
  foodSettings() {
    return apiContractRequest("/api/owner/nutrition/settings");
  },
  updateFoodSettings(payload) {
    return apiContractRequest("/api/owner/nutrition/settings", jsonPatch(payload));
  },
  listLifeEntries({ status = "inbox", limit = 40 } = {}) {
    return apiContractRequest("/api/owner/life/entries", { params: { status, limit } });
  },
  createLifeEntry(payload) {
    return apiContractRequest("/api/owner/life/entries", jsonPost(payload));
  },
  updateLifeEntry(entryId, payload) {
    return apiContractRequest(`/api/owner/life/entries/${encodeURIComponent(entryId)}`, jsonPatch(payload));
  },
  deleteLifeEntry(entryId) {
    return apiContractRequest(`/api/owner/life/entries/${encodeURIComponent(entryId)}`, jsonDelete());
  },
  resolveLifeEntryRetrospective(entryId, payload = {}) {
    return apiContractRequest(`/api/owner/life/entries/${entryId}/retrospective`, jsonPost(payload));
  },
  listCommitments({ status = "open", operationalState = "", limit = 80 } = {}) {
    return apiContractRequest("/api/owner/life/commitments", { params: { status, operationalState, limit } });
  },
  reconcileCommitments(payload = {}) {
    return apiContractRequest("/api/owner/life/commitments/reconcile", jsonPost(payload));
  },
  createCommitment(payload) {
    return apiContractRequest("/api/owner/life/commitments", jsonPost(payload));
  },
  updateCommitment(commitmentId, payload) {
    return apiContractRequest(`/api/owner/life/commitments/${commitmentId}`, jsonPatch(payload));
  },
  deleteCommitment(commitmentId) {
    return apiContractRequest(`/api/owner/life/commitments/${commitmentId}`, jsonDelete());
  },
  timeEntries({ days = 14, from = "", to = "", area = "", limit = 500, tzOffsetMinutes = new Date().getTimezoneOffset() } = {}) {
    return apiContractRequest("/api/owner/life/time", { params: { days, from, to, area, limit, tzOffsetMinutes } });
  },
  createTodayBlock(payload = {}) {
    return apiContractRequest("/api/owner/calendar/activity/history", jsonPost(payload));
  },
  correctTodayManualTime(entryId, payload = {}) {
    return apiContractRequest(`/api/owner/calendar/time/${encodeURIComponent(entryId)}`, jsonPatch(payload));
  },
  voidTodayManualTime(entryId, payload = {}) {
    return apiContractRequest(`/api/owner/calendar/time/${encodeURIComponent(entryId)}/void`, jsonPost(payload));
  },
  correctTodaySession(sessionId, payload = {}) {
    return apiContractRequest(`/api/owner/calendar/activity/${encodeURIComponent(sessionId)}`, jsonPatch(payload));
  },
  correctTodayParallel(sessionId, parallelId, payload = {}) {
    return apiContractRequest(`/api/owner/calendar/activity/${encodeURIComponent(sessionId)}/parallel/${encodeURIComponent(parallelId)}`, jsonPatch(payload));
  },
  voidTodayParallel(sessionId, parallelId, payload = {}) {
    return apiContractRequest(`/api/owner/calendar/activity/${encodeURIComponent(sessionId)}/parallel/${encodeURIComponent(parallelId)}/void`, jsonPost(payload));
  },
  voidTodaySession(sessionId, payload = {}) {
    return apiContractRequest(`/api/owner/calendar/activity/${encodeURIComponent(sessionId)}/void`, jsonPost(payload));
  },
  createTimeEntry(payload = {}) {
    return apiContractRequest("/api/owner/life/time", jsonPost(payload));
  },
  listCommitmentTime(commitmentId) {
    return apiContractRequest(`/api/owner/life/commitments/${commitmentId}/time`);
  },
  addCommitmentTime(commitmentId, payload) {
    return apiContractRequest(`/api/owner/life/commitments/${commitmentId}/time`, jsonPost(payload));
  },
  updateTimeEntry(entryId, payload) {
    return apiContractRequest(`/api/owner/life/time/${encodeURIComponent(entryId)}`, jsonPatch(payload));
  },
  deleteTimeEntry(entryId) {
    return apiContractRequest(`/api/owner/life/time/${encodeURIComponent(entryId)}`, jsonDelete());
  },
  listInitiatives({ status = "active", limit = 40 } = {}) {
    return apiContractRequest("/api/owner/life/initiatives", { params: { status, limit } });
  },
  createInitiative(payload) {
    return apiContractRequest("/api/owner/life/initiatives", jsonPost(payload));
  },
  getInitiative(initiativeId) {
    return apiContractRequest(`/api/owner/life/initiatives/${initiativeId}`);
  },
  initiativeContext(initiativeId) {
    return apiContractRequest(`/api/owner/life/initiatives/${initiativeId}/context`);
  },
  createProjectSteps(initiativeId, steps) {
    return apiContractRequest(`/api/owner/life/initiatives/${initiativeId}/steps`, jsonPost({ steps }));
  },
  reorderProjectSteps(initiativeId, stepIds) {
    return apiContractRequest(`/api/owner/life/initiatives/${initiativeId}/steps/order`, jsonPatch({ stepIds }));
  },
  deleteProjectStep(initiativeId, stepId) {
    return apiContractRequest(`/api/owner/life/initiatives/${initiativeId}/steps/${stepId}`, jsonDelete());
  },
  projectDailyLoop(initiativeId) {
    return apiContractRequest(`/api/owner/life/initiatives/${initiativeId}/daily-loop`);
  },
  answerProjectDailyLoop(initiativeId, payload) {
    return apiContractRequest(`/api/owner/life/initiatives/${initiativeId}/daily-loop/answer`, jsonPost(payload));
  },
  initiativeEconomics(initiativeId) {
    return apiContractRequest(`/api/owner/life/initiatives/${initiativeId}/economics`);
  },
  initiativeProductHealth(initiativeId, { days = 30 } = {}) {
    return apiContractRequest(`/api/owner/life/initiatives/${initiativeId}/product-health`, { params: { days } });
  },
  projectErpResetPreview(initiativeId, projectId = "") {
    return apiContractRequest(`/api/owner/life/initiatives/${initiativeId}/erp-reset/preview`, { params: projectId ? { projectId } : {} });
  },
  resetProjectErp(initiativeId, payload) {
    return apiContractRequest(`/api/owner/life/initiatives/${initiativeId}/erp-reset`, jsonPost(payload));
  },
  updateInitiative(initiativeId, payload) {
    return apiContractRequest(`/api/owner/life/initiatives/${initiativeId}`, jsonPatch(payload));
  },
  // WP-OWNER-PROTOCOL | PATCH 3 | Explicit responsibility/attention mutation only.
  // Test status: backend UNIT_TESTED; frontend runtime pending.
  updateInitiativeOwnerAttention(initiativeId, payload) {
    return apiContractRequest(`/api/owner/life/initiatives/${initiativeId}/owner-attention`, jsonPatch(payload));
  },
  bulkUpdateInitiativeOwnerAttention(updates) {
    return apiContractRequest("/api/owner/life/initiatives/owner-attention/bulk", jsonPatch({ updates }));
  },
  deleteInitiative(initiativeId) {
    return apiContractRequest(`/api/owner/life/initiatives/${initiativeId}`, { method: "DELETE" });
  },
  projectAgreement(initiativeId) {
    return apiContractRequest(`/api/owner/life/initiatives/${initiativeId}/agreement`);
  },
  syncProjectWebProfitBilling(initiativeId) {
    return apiContractRequest(`/api/owner/life/initiatives/${initiativeId}/agreement/webprofit-billing/sync`, jsonPost({}));
  },
  createProjectTerm(initiativeId, payload) {
    return apiContractRequest(`/api/owner/life/initiatives/${initiativeId}/agreement/terms`, jsonPost(payload));
  },
  updateProjectTerm(initiativeId, termId, payload) {
    return apiContractRequest(`/api/owner/life/initiatives/${initiativeId}/agreement/terms/${termId}`, jsonPatch(payload));
  },
  linkProjectMonthlyBilling(initiativeId, termId) {
    return apiContractRequest(`/api/owner/life/initiatives/${initiativeId}/agreement/terms/${termId}/webprofit-billing/link`, jsonPost({}));
  },
  unlinkProjectMonthlyBilling(initiativeId, termId) {
    return apiContractRequest(`/api/owner/life/initiatives/${initiativeId}/agreement/terms/${termId}/webprofit-billing/unlink`, jsonPost({}));
  },
  splitProjectInstallmentExcess(initiativeId, termId, payload) {
    return apiContractRequest(`/api/owner/life/initiatives/${initiativeId}/agreement/terms/${termId}/installment-excess/split`, jsonPost(payload));
  },
  bulkLinkProjectMonthlyHistory(initiativeId, termId, payload) {
    return apiContractRequest(`/api/owner/life/initiatives/${initiativeId}/agreement/terms/${termId}/monthly-history/link`, jsonPost(payload));
  },
  configureProjectMonthlyConcession(initiativeId, termId, payload) {
    return apiContractRequest(`/api/owner/life/initiatives/${initiativeId}/agreement/terms/${termId}/monthly-concession/configure`, jsonPost(payload));
  },
  resolveProjectMonthlyNextCharge(initiativeId, termId, choice) {
    return apiContractRequest(`/api/owner/life/initiatives/${initiativeId}/agreement/terms/${termId}/monthly-concession/next-charge`, jsonPost({ choice }));
  },
  createProjectPaymentPlan(initiativeId, payload) {
    return apiContractRequest(`/api/owner/life/initiatives/${initiativeId}/agreement/payments`, jsonPost(payload));
  },
  updateProjectPaymentPlan(initiativeId, paymentPlanId, payload) {
    return apiContractRequest(`/api/owner/life/initiatives/${initiativeId}/agreement/payments/${paymentPlanId}`, jsonPatch(payload));
  },
  reconcileProjectPaymentPlan(initiativeId, paymentPlanId, transactionId) {
    return apiContractRequest(`/api/owner/life/initiatives/${initiativeId}/agreement/payments/${paymentPlanId}/reconcile`, jsonPost({ transactionId }));
  },
  setProjectRecurringAttribution(initiativeId, recurringPlanId, payload) {
    return apiContractRequest(`/api/owner/life/initiatives/${initiativeId}/agreement/recurring/${recurringPlanId}/attribution`, jsonPatch(payload));
  },
  bulkLinkProjectPayments(payload) {
    return apiContractRequest("/api/owner/finance/transactions/bulk-project", jsonPost(payload));
  },

  memories({ from, to, limit = 280, tzOffsetMinutes = new Date().getTimezoneOffset() } = {}) {
    return apiContractRequest("/api/owner/memories", { params: { from, to, limit, tzOffsetMinutes } });
  },
  navigationLearning({ limit = 400 } = {}) {
    return apiContractRequest("/api/owner/navigation-learning", { params: { limit } });
  },
  recordNavigationLearning(payload) {
    return apiContractRequest("/api/owner/navigation-learning/feedback", jsonPost(payload));
  },

  listFinanceAccounts() {
    return apiContractRequest("/api/owner/finance/accounts");
  },
  createFinanceAccount(payload) {
    return apiContractRequest("/api/owner/finance/accounts", jsonPost(payload));
  },
  updateFinanceAccount(accountId, payload) {
    return apiContractRequest(`/api/owner/finance/accounts/${accountId}`, jsonPatch(payload));
  },
  listFinanceCategories({ includeArchived = false } = {}) {
    return apiContractRequest("/api/owner/finance/categories", { params: { includeArchived } });
  },
  createFinanceCategory(payload) {
    return apiContractRequest("/api/owner/finance/categories", jsonPost(payload));
  },
  updateFinanceCategory(categoryId, payload) {
    return apiContractRequest(`/api/owner/finance/categories/${categoryId}`, jsonPatch(payload));
  },
  // OWNER_FINANCE_PRO_V2 · STATUS: STATIC_PASS · RUNTIME_PENDING
  // Keep this method backward compatible: the original callers can keep sending
  // only `limit`, while the Owner money workspace can request richer server-side filters.
  listFinanceTransactions({
    limit = 80, page = 1, q = "", type = "", category = "", accountId = "", currency = "",
    area = "", sourceKind = "", sortBy = "", from = "", to = "", clientId = "", initiativeId = "", projectTermId = "",
  } = {}) {
    return apiContractRequest("/api/owner/finance/transactions", {
      params: {
        limit, page,
        ...(q ? { q } : {}), ...(type ? { type } : {}), ...(category ? { category } : {}),
        ...(accountId ? { accountId } : {}), ...(currency ? { currency } : {}), ...(area ? { area } : {}),
        ...(sourceKind ? { sourceKind } : {}), ...(sortBy ? { sortBy } : {}), ...(from ? { from } : {}), ...(to ? { to } : {}),
        ...(clientId ? { clientId } : {}), ...(initiativeId ? { initiativeId } : {}),
        ...(projectTermId ? { projectTermId } : {}),
      },
    });
  },
  exportOwnerMoneyAudit({ format = "json", sourceKind = "", from = "", to = "", dateField = "occurredAt" } = {}) {
    return apiContractRequest("/api/owner/finance/audit/export", {
      params: { format, dateField, ...(sourceKind ? { sourceKind } : {}), ...(from ? { from } : {}), ...(to ? { to } : {}) },
      timeout: 120000,
    });
  },
  financeMovementOptions() {
    return apiContractRequest("/api/owner/finance/movement-options");
  },
  createFinanceTransaction(payload) {
    return apiContractRequest("/api/owner/finance/transactions", jsonPost(payload));
  },
  updateFinanceTransaction(transactionId, payload) {
    return apiContractRequest(`/api/owner/finance/transactions/${transactionId}`, jsonPatch(payload));
  },
  listInventoryItems({ query = "", area = "", limit = 100 } = {}) {
    return apiContractRequest("/api/owner/inventory/items", { params: { ...(query ? { query } : {}), ...(area ? { area } : {}), limit } });
  },
  listInventoryMovements({ limit = 60 } = {}) {
    return apiContractRequest("/api/owner/inventory/movements", { params: { limit } });
  },
  createInventoryMovement(payload) {
    return apiContractRequest("/api/owner/inventory/movements", jsonPost(payload));
  },
  updateInventoryItem(itemId, payload) {
    return apiContractRequest(`/api/owner/inventory/items/${encodeURIComponent(itemId)}`, jsonPatch(payload));
  },
  parseFoodStockIntake(text) {
    return apiContractRequest("/api/owner/inventory/food-bootstrap/parse", jsonPost({ text }));
  },
  commitFoodStockIntake(items) {
    return apiContractRequest("/api/owner/inventory/food-bootstrap/commit", jsonPost({ items }));
  },
  listRecurringFinance({ includeEnded = false } = {}) {
    return apiContractRequest("/api/owner/finance/recurring", { params: { includeEnded } });
  },
  createRecurringFinance(payload) {
    return apiContractRequest("/api/owner/finance/recurring", jsonPost(payload));
  },
  updateRecurringFinance(planId, payload) {
    return apiContractRequest(`/api/owner/finance/recurring/${planId}`, jsonPatch(payload));
  },
  deleteRecurringFinance(planId) {
    return apiContractRequest(`/api/owner/finance/recurring/${planId}`, jsonDelete());
  },
  listRecurringOccurrences(planId, { near = "", limit = 24 } = {}) {
    return apiContractRequest(`/api/owner/finance/recurring/${planId}/occurrences`, { params: { ...(near ? { near } : {}), limit } });
  },
  updateRecurringOccurrence(planId, periodKey, payload) {
    return apiContractRequest(`/api/owner/finance/recurring/${planId}/occurrences/${encodeURIComponent(periodKey)}`, jsonPatch(payload));
  },
  recordRecurringFinance(planId, payload) {
    return apiContractRequest(`/api/owner/finance/recurring/${planId}/record`, jsonPost(payload));
  },
  linkFinanceTransactionRecurring(transactionId, payload) {
    return apiContractRequest(`/api/owner/finance/transactions/${transactionId}/recurring`, jsonPost(payload));
  },
  listInfrastructure({ includeEnded = false } = {}) {
    return apiContractRequest("/api/owner/finance/infrastructure", { params: { includeEnded } });
  },
  createInfrastructure(payload) {
    return apiContractRequest("/api/owner/finance/infrastructure", jsonPost(payload));
  },
  updateInfrastructure(poolId, payload) {
    return apiContractRequest(`/api/owner/finance/infrastructure/${poolId}`, jsonPatch(payload));
  },
  endInfrastructure(poolId) {
    return apiContractRequest(`/api/owner/finance/infrastructure/${poolId}`, jsonDelete());
  },
  createFinanceImport(file) {
    return apiContractRequest("/api/owner/finance/imports", {
      method: "POST",
      body: buildOwnerImportFormData(file),
    });
  },
  previewFinanceImport(importId) {
    return apiContractRequest(`/api/owner/finance/imports/${encodeURIComponent(importId)}/preview`, jsonPost({}));
  },
  commitFinanceImport(importId) {
    return apiContractRequest(`/api/owner/finance/imports/${encodeURIComponent(importId)}/commit`, jsonPost({}));
  },

  commercialSummary() {
    return apiContractRequest("/api/owner/commercial/summary");
  },
  listClients({ status = "", query = "", limit = 250 } = {}) {
    return apiContractRequest("/api/owner/commercial/clients", { params: { ...(status ? { status } : {}), ...(query ? { query } : {}), limit } });
  },
  createClient(payload) {
    return apiContractRequest("/api/owner/commercial/clients", jsonPost(payload));
  },
  ensureClientProjects() {
    return apiContractRequest("/api/owner/commercial/clients/ensure-projects", jsonPost({ limit: 500 }));
  },
  updateClient(clientId, payload) {
    return apiContractRequest(`/api/owner/commercial/clients/${clientId}`, jsonPatch(payload));
  },
  searchWebProfitUsers({ query = "", limit = 20 } = {}) {
    return apiContractRequest("/api/owner/webprofit/users", { params: { query, limit } });
  },
  searchWebProfitProjects({ query = "", limit = 20 } = {}) {
    return apiContractRequest("/api/owner/webprofit/projects", { params: { query, limit } });
  },
  clientWebProfitContext(clientId) {
    return apiContractRequest(`/api/owner/people/${clientId}/webprofit`);
  },
  linkClientWebProfitUser(clientId, userId) {
    return apiContractRequest(`/api/owner/people/${clientId}/webprofit`, jsonPatch({ userId: userId || null }));
  },
  linkClientWebProfitProject(clientId, projectId, linked = true) {
    return apiContractRequest(`/api/owner/people/${clientId}/webprofit/projects/${projectId}`, jsonPatch({ linked }));
  },
  peopleFocus({ limit = 20 } = {}) {
    return apiContractRequest("/api/owner/people/focus", { params: { limit } });
  },
  personContext(clientId) {
    return apiContractRequest(`/api/owner/people/${clientId}/context`);
  },
  clientChatGptExport(clientId) {
    return apiContractRequest(`/api/owner/people/${clientId}/chatgpt-export`);
  },
  listInteractions(clientId, { limit = 60 } = {}) {
    return apiContractRequest(`/api/owner/people/${clientId}/interactions`, { params: { limit } });
  },
  createInteraction(clientId, payload) {
    return apiContractRequest(`/api/owner/people/${clientId}/interactions`, jsonPost(payload));
  },
  listServices({ includeInactive = true } = {}) {
    return apiContractRequest("/api/owner/commercial/services", { params: { includeInactive } });
  },
  createService(payload) {
    return apiContractRequest("/api/owner/commercial/services", jsonPost(payload));
  },
  updateService(serviceId, payload) {
    return apiContractRequest(`/api/owner/commercial/services/${serviceId}`, jsonPatch(payload));
  },
  listSales({ limit = 120, status = "" } = {}) {
    return apiContractRequest("/api/owner/commercial/sales", {
      params: { limit, ...(status ? { status } : {}) },
    });
  },
  createSale(payload) {
    return apiContractRequest("/api/owner/commercial/sales", jsonPost(payload));
  },
  updateSaleStatus(saleId, status) {
    return apiContractRequest(`/api/owner/commercial/sales/${saleId}/status`, jsonPatch({ status }));
  },
  listSalePayments(saleId) {
    return apiContractRequest(`/api/owner/commercial/sales/${saleId}/payments`);
  },
  createSalePayment(saleId, payload) {
    return apiContractRequest(`/api/owner/commercial/sales/${saleId}/payments`, jsonPost(payload));
  },
};
